import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

import AsideView from '@uicomponents/AsideView';

import PricingModuleForm from './PricingModuleForm';

class PricingModuleFormPage extends Component {
  render() {
    const { t, headerName } = this.props;
    return (
      <AsideView>
        <div className="step-form">
          <form className="form active no-padding-top">
            <h1 className="center">
              {headerName ? headerName : t('pricing.module.create.header')}
            </h1>
            <PricingModuleForm {...this.props} />
          </form>
        </div>
      </AsideView>
    );
  }
}
export default withTranslation('translation')(PricingModuleFormPage);
